<div *ngIf="showGlobalSpinner" class="loading">
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>
<div breadcrumbs [option]='breadcrumbOptions'></div>

<!-- <div class="heading">
  <h3>Manage Venues</h3>
</div> -->

<div class="container-fluid mt-4" *ngIf="venue && editingVenue">

  <div class="row">
    <div class="col-md-12">
      <div class="row mb-3">
      <h2 class="h2-venue">{{ venue.venueName }}</h2>
        <div class="col-md-4 text-end">
          <button *ngIf="!editMode" class="btn btn-primary btn-primary-2-edit bt-rounded" (click)="toggleEditMode()">Edit
            Details</button>
          <ng-container *ngIf="editMode">
            <button class="btn btn-success me-2 bt-rounded" (click)="saveVenue()">Save Changes</button>
            <button class="btn btn-outline-secondary bt-rounded" (click)="cancelEdit()">Cancel</button>
          </ng-container>
        </div>
      </div>
      <div class="card mb-4">
        <div class="card-header card-header-2 d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <h4 class="mb-0 section-title">Venue Information</h4>
            <span class="ms-3">
              <span *ngIf="!editMode" class="badge bg-secondary bt-rounded">View Mode</span>
              <span *ngIf="editMode" class="badge bg-primary bt-rounded">Edit Mode</span>
            </span>
          </div>
        </div>
        <div class="card-body">
          <!-- EDIT MODE - FORM CONTROLS -->
          <div *ngIf="editMode">
            <div class="row">
              <div class="col-md-6 mb-3 form-group">
                <label for="venueName" class="form-label field-header">
                  VENUE NAME
                  <span *ngIf="isFieldEdited('venueName')" class="field-edit-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-pencil-fill" viewBox="0 0 16 16">
                      <path
                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg>
                  </span>
                </label>
                <div class="position-relative">
                  <input type="text" class="form-control" id="venueName" [(ngModel)]="editingVenue!.venueName"
                    (ngModelChange)="onFieldChange('venueName')"
                    [ngClass]="{'field-edited': isFieldEdited('venueName')}" disabled>
                  <div *ngIf="isFieldEdited('venueName')" class="field-highlight"></div>
                </div>
              </div>
              <div class="col-md-6 mb-3 form-group">
                <label for="location" class="form-label field-header">
                  LOCATION
                  <span *ngIf="isFieldEdited('location')" class="field-edit-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-pencil-fill" viewBox="0 0 16 16">
                      <path
                        d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                    </svg>
                  </span>
                </label>
                <div class="position-relative">
                  <input type="text" class="form-control" id="location" [(ngModel)]="editingVenue!.location"
                    (ngModelChange)="onFieldChange('location')" [ngClass]="{'field-edited': isFieldEdited('location')}">
                  <div *ngIf="isFieldEdited('location')" class="field-highlight"></div>
                </div>
              </div>
            </div>
            <div class="mb-3 form-group">
              <label for="shortDesc" class="form-label field-header">
                SHORT DESCRIPTION
                <span *ngIf="isFieldEdited('shortDesc')" class="field-edit-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                  </svg>
                </span>
              </label>
              <div class="position-relative">
                <input type="text" class="form-control" id="shortDesc" [(ngModel)]="editingVenue!.shortDesc"
                   (ngModelChange)="onFieldChange('shortDesc'); updateCharCount()"
                  [ngClass]="{'field-edited': isFieldEdited('shortDesc')}" 
                  maxlength="500">
                <div *ngIf="isFieldEdited('shortDesc')" class="field-highlight"></div>
                <small class="text-muted char-counter" 
                       [ngClass]="{'char-limit-warning': (editingVenue?.shortDesc?.length || 0) > 480}">
                  {{ editingVenue?.shortDesc?.length || 0 }}/500
                </small>
              </div>
            </div>

            <div class="mb-3 form-group">
              <label for="longDesc" class="form-label field-header">
                DETAILED DESCRIPTION
                <span *ngIf="isFieldEdited('longDesc')" class="field-edit-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                  </svg>
                </span>
              </label>
              <!-- <div class="position-relative">
                <textarea class="form-control" id="longDesc" rows="3" [(ngModel)]="editingVenue!.longDesc"
                  (ngModelChange)="onFieldChange('longDesc')"
                  [ngClass]="{'field-edited': isFieldEdited('longDesc')}"></textarea>
                <div *ngIf="isFieldEdited('longDesc')" class="field-highlight"></div>
              </div> -->
                 <div class="position-relative">
                  <ngx-editor-menu class="rich-text-tool" [editor]="editor"
                  [toolbar]="toolbar"> </ngx-editor-menu>
                  <ngx-editor
                  [(ngModel)]="editingVenue!.longDesc" 
                  (ngModelChange)="onFieldChange('longDesc')" [editor]="editor" [disabled]="false" [placeholder]="'Add detailed description'">
                  </ngx-editor>
            </div>
            </div>
            <div class="mb-3 form-group">
              <label for="mLink" class="form-label field-header">
                MENU LINK
                <span *ngIf="isFieldEdited('links')" class="field-edit-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                    <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                  </svg>
                </span>
              </label>
              <div class="position-relative">
                <input type="url" class="form-control" id="links" [(ngModel)]="editingVenue!.links"
                  (ngModelChange)="onFieldChange('links')" [ngClass]="{'field-edited': isFieldEdited('links')}">
                <div *ngIf="isFieldEdited('links')" class="field-highlight"></div>
              </div>
            </div>
          </div>
          <!-- VIEW MODE - DISPLAY CONTENT -->
          <div *ngIf="!editMode">
            <div class="mb-4">
              <div class="row mb-3">
                <div class="col-md-6">
                  <div class="field-container">
                    <div class="field-label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-building me-2" viewBox="0 0 16 16">
                        <path
                          d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-10Zm.5.5v9h6v-9h-6Z" />
                        <path
                          d="M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2Zm11 1a1 1 0 0 0-1-1h-1.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5H12a1 1 0 0 0 1-1V3Z" />
                      </svg>
                      VENUE NAME
                    </div>
                    <div class="field-value">{{ editingVenue!.venueName }}</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="field-container">
                    <div class="field-label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-geo-alt" viewBox="0 0 16 16">
                        <path
                          d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                        <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                      </svg>
                      LOCATION
                    </div>
                    <div class="field-value">{{ editingVenue!.location || 'Not specified' }}</div>
                  </div>
                </div>
              </div>

              <div class="field-container mb-3">
                <div class="field-label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-card-text" viewBox="0 0 16 16">
                    <path
                      d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                    <path
                      d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
                  </svg>
                  SHORT DESCRIPTION
                </div>
                <div class="field-value">{{ editingVenue!.shortDesc || 'No description available' }}</div>
              </div>
              <div class="field-container" *ngIf="editingVenue!.longDesc">
                <div class="field-label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-file-text" viewBox="0 0 16 16">
                    <path
                      d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                    <path
                      d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                  </svg>
                  DETAILED DESCRIPTION
                </div>
                <div class="field-value"[innerHTML]="getSanitizedHtml(editingVenue!.longDesc)"></div>
              </div>

              <div class="field-container" *ngIf="!editingVenue!.longDesc">
                <div class="field-label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-file-text" viewBox="0 0 16 16">
                    <path
                      d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                    <path
                      d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                  </svg>
                  DETAILED DESCRIPTION
                </div>
                <div class="field-value text-muted">No detailed description available</div>
              </div>

              <div class="field-container">
                <div class="field-label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path
                      d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" />
                    <path
                      d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" />
                  </svg>
                  MENU LINK
                </div>
                <div class="field-value">
                  <a *ngIf="editingVenue!.links" [href]="editingVenue!.links" target="_blank">{{
                    editingVenue!.links }}</a>
                  <span *ngIf="!editingVenue!.links" class="text-muted">No menu link available</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header card-header-2">
          <h4 class="mb-0 section-title">Hours of Operation</h4>
          <span class="ms-3">
            <span *ngIf="!editMode" class="badge bg-secondary bt-rounded">View Mode</span>
            <span *ngIf="editMode" class="badge bg-primary bt-rounded">Edit Mode</span>
          </span>
        </div>
        <div class="card-body">
          <div class="row days-row">
            <div class="col-md-6 col-lg-4 col-xl-3 mb-3"
              *ngFor="let dayHours of editingVenue.hours; let dayIndex = index">
              <div class="card mb-3 hours-card">
                <div class="card mb-3 hours-card">
                  <div class="card-header hours-day-header" [ngClass]="{
                      'day-header-closed': getStatusAsNumber(dayHours) === 0,
                      'day-header-open': getStatusAsNumber(dayHours) !== 0,
                      'status-edited': isDayStatusEdited(dayHours.day)
                    }">

                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <h5 class="mb-0">{{ dayHours.day }}</h5>
                        <span *ngIf="isDayStatusEdited(dayHours.day)" class="edit-indicator">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-asterisk" viewBox="0 0 16 16">
                            <path
                              d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z" />
                          </svg>
                        </span>
                      </div>
                      <select *ngIf="editMode" class="form-select w-auto status-select" [ngModel]="dayHours.status"
                        (ngModelChange)="dayHours.status = $event; onStatusChange(dayHours)"
                        [ngClass]="{'field-edited': isDayStatusEdited(dayHours.day)}">
                        <option [ngValue]="0">Closed</option>
                        <option [ngValue]="1">All Day</option>
                        <option [ngValue]="2">Open Hours</option>
                        <option [ngValue]="3">Open (Meal Periods)</option>
                      </select>
                      <span *ngIf="!editMode" class="status-badge">
                        {{ getStatusAsNumber(dayHours) === 0 ? 'Closed' :
                        getStatusAsNumber(dayHours) === 1 ? 'All Day' :
                        getStatusAsNumber(dayHours) === 2 ? 'Open Hours' :
                        'Open (Meal Periods)' }}
                      </span>
                    </div>
                  </div>

                  <div class="card-body hours-content">
                    <!-- EDIT MODE - Default Hours -->
                    <div *ngIf="editMode && getStatusAsNumber(dayHours) === 2">
                      <div class="row" *ngFor="let meal of dayHours.mealPeriods; let i = index">
                        <div class="col-12 mb-2">
                          <div class="d-flex align-items-center meal-header">
                            <span class="meal-name">{{ meal.mealName }}</span>
                          </div>
                        </div>
                        <div class="col-12 hour-input-parent">
                          <div class="row g-2 hour-input">
                            <div class="col-12">
                              <div class="input-group input-group-sm">
                                <span class="input-group-text">Opens</span>
                                <input type="time" class="form-control" [(ngModel)]="meal.openTime"
                                  (ngModelChange)="onTimeChange(dayHours.day, meal, 'openTime')"
                                  [ngClass]="{'field-edited': isMealTimeEdited(dayHours.day, meal.mealName, 'openTime')}">
                                <span *ngIf="isMealTimeEdited(dayHours.day, meal.mealName, 'openTime')"
                                  class="input-group-text modified-indicator">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="input-group input-group-sm">
                                <span class="input-group-text">Closes</span>
                                <input type="time" class="form-control" [(ngModel)]="meal.closeTime"
                                  (ngModelChange)="onTimeChange(dayHours.day, meal, 'closeTime')"
                                  [ngClass]="{'field-edited': isMealTimeEdited(dayHours.day, meal.mealName, 'closeTime')}">
                                <span *ngIf="isMealTimeEdited(dayHours.day, meal.mealName, 'closeTime')"
                                  class="input-group-text modified-indicator">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- VIEW MODE - Default Hours -->
                    <div *ngIf="!editMode && getStatusAsNumber(dayHours) === 2">
                      <div *ngFor="let meal of dayHours.mealPeriods; let i = index">
                        <p class="mb-0 hours-display">
                          <strong>Hours:</strong> {{ formatTime(meal.openTime) }} - {{ formatTime(meal.closeTime) }}
                        </p>
                      </div>
                    </div>

                    <!-- EDIT MODE - Meal Periods -->
                    <div *ngIf="editMode && getStatusAsNumber(dayHours) === 3">
                      <div class="row mb-3" *ngFor="let meal of dayHours.mealPeriods; let i = index">
                        <div class="col-12 mb-2">
                          <div class="d-flex align-items-center justify-content-between meal-header">
                            <div class="d-flex align-items-center">
                              <span class="meal-name">{{ meal.mealName }}</span>
                              <span *ngIf="isMealClosedEdited(dayHours.day, meal.mealName)" class="edit-badge-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                                  class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                  <path
                                    d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                                  <path fill-rule="evenodd"
                                    d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                                </svg>
                              </span>
                            </div>
                            <!-- <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" [id]="'closed-'+dayIndex+'-'+i"
                              [(ngModel)]="meal.isClosed" (ngModelChange)="onMealClosedChange(dayHours.day, meal)"
                              [ngClass]="{'field-edited': isMealClosedEdited(dayHours.day, meal.mealName)}">
                            <label class="form-check-label" [for]="'closed-'+dayIndex+'-'+i">
                              Closed
                            </label>
                          </div> -->
                            <div class="custom-toggle-wrapper">
                              <label class="custom-switch">
                                <input type="checkbox" class="custom-switch-input" [id]="'closed-' + dayIndex + '-' + i"
                                  [(ngModel)]="meal.isClosed" (ngModelChange)="onMealClosedChange(dayHours.day, meal)"
                                  [ngClass]="{ 'field-edited': isMealClosedEdited(dayHours.day, meal.mealName) }" />
                                <span class="custom-switch-slider"></span>
                                <span class="custom-switch-label">Closed</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 hour-input-parent" *ngIf="!meal.isClosed"> 
                          <div class="row g-2 hour-input">
                            <div class="col-12">
                              <div class="input-group input-group-sm">
                                <span class="input-group-text">Opens</span>
                                <input type="time" class="form-control" [(ngModel)]="meal.openTime"
                                  (ngModelChange)="onTimeChange(dayHours.day, meal, 'openTime')"
                                  [ngClass]="{'field-edited': isMealTimeEdited(dayHours.day, meal.mealName, 'openTime')}">
                                <span *ngIf="isMealTimeEdited(dayHours.day, meal.mealName, 'openTime')"
                                  class="input-group-text modified-indicator">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </span>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="input-group">
                                <span class="input-group-text input-group-sm">Closes</span>
                                <input type="time" class="form-control" [(ngModel)]="meal.closeTime"
                                  (ngModelChange)="onTimeChange(dayHours.day, meal, 'closeTime')"
                                  [ngClass]="{'field-edited': isMealTimeEdited(dayHours.day, meal.mealName, 'closeTime')}">
                                <span *ngIf="isMealTimeEdited(dayHours.day, meal.mealName, 'closeTime')"
                                  class="input-group-text modified-indicator">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                    <path
                                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 text-center py-2" *ngIf="meal.isClosed">
                          <span class="badge bg-danger">Closed for {{ meal.mealName }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- VIEW MODE - Meal Periods -->
                    <div *ngIf="!editMode && getStatusAsNumber(dayHours) === 3">
                      <div *ngFor="let meal of dayHours.mealPeriods; let i = index" class="mb-2">
                        <div class="d-flex align-items-center meal-period">
                          <div class="meal-name">{{ meal.mealName }} :</div>
                          <div class="meal-time">
                            <span *ngIf="meal.isClosed" class="badge bg-danger">Closed</span>
                            <span *ngIf="!meal.isClosed" class="meal-hours">
                              {{ formatTime(meal.openTime) }} - {{ formatTime(meal.closeTime) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Closed All Day (Both Modes) -->
                    <div *ngIf="getStatusAsNumber(dayHours) === 0" class="text-center py-3">
                      <span class="closed-all-day">Closed All Day</span>
                    </div>
                    <div *ngIf="getStatusAsNumber(dayHours) === 1" class="text-center py-3">
                      <span class="open-all-day">Open All Day</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="editMode" class="d-flex justify-content-end mb-4">
          <button class="btn btn-success me-2" (click)="saveVenue()">Save Changes</button>
          <button class="btn btn-outline-secondary" (click)="cancelEdit()">Cancel</button>
        </div> -->

        <!-- <div *ngIf="errorMessage" class="alert alert-danger mt-3">
          {{ errorMessage }}
        </div> -->

        <!-- <div *ngIf="successMessage" class="alert alert-success mt-3">
          {{ successMessage }}
        </div> -->

        <!-- <div *ngIf="hasChanges && editMode" class="alert alert-warning mt-3">
          <strong>Pending Changes:</strong>
          <ul>
            <li *ngIf="hasBasicInfoChanges">Venue information has been modified</li>
            <li *ngIf="hasHoursChanges">Hours of operation have been modified</li>
          </ul>
        </div> -->
      </div>
    </div>
  </div>

  <div class="container mt-4" *ngIf="!venue && !errorMessage">
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>